<section class="mb-4 rounded-lg border border-gray-200 bg-white p-4">
  <div class="mb-4 flex items-center justify-between">
    <h2 class="text-lg text-primary-500">
      {{ "accountMenu.usersManagement.title" | transloco }}
    </h2>
    @if (currentUserService.isAdmin()) {
      <div class="flex justify-start">
        @if (packLimitationService.canCreateUser()) {
          <app-user-form-popup
            mode="create"
            (emitUserDTO)="createUser($event)"
            [loading]="isLoading"
          />
        } @else {
          <app-locked-button
            [label]="'accountMenu.usersManagement.addUser' | transloco"
            [limitedFeature]="createUserFeature"
          />
        }
      </div>
    }
  </div>

  <p-confirmdialog />

  @if (isLoadingUsers) {
    <div class="flex items-center justify-center py-8">
      <i class="pi pi-spin pi-spinner text-2xl text-primary-500"></i>
    </div>
  } @else {
    <div class="mb-4 grid grid-cols-1 gap-4 md:grid-cols-2">
      @for (user of userList; track user.id) {
        <article class="rounded-lg border border-gray-200 bg-greyscale-50 p-4">
          <!-- Header avec avatar + nom -->
          <div class="mb-3 flex items-center gap-3">
            <div
              class="flex h-10 w-10 items-center justify-center rounded-full bg-primary-200 text-sm font-semibold text-primary-700"
            >
              {{ getInitials(user) }}
            </div>
            <span class="font-medium text-gray-900">
              {{ user.firstName }} {{ user.lastName }}
            </span>
          </div>

          <!-- Email -->
          <div class="mb-2 flex items-center gap-2 text-sm text-gray-600">
            <lucide-angular [img]="mailIcon" class="h-4 w-4" />
            <span class="truncate">{{ user.emails[0].email }}</span>
          </div>

          <!-- Role badge -->
          <div class="mb-4 flex items-center gap-2 text-sm text-gray-600">
            <lucide-angular [img]="tagIcon" class="h-4 w-4" />
            <span
              class="rounded-full px-2 py-0.5 text-xs font-medium"
              [class]="
                user.role === 'admin' || user.role === 'superAdmin'
                  ? 'bg-primary-100 text-primary-700'
                  : 'bg-gray-200 text-gray-700'
              "
            >
              {{
                user.role === "admin" || user.role === "superAdmin"
                  ? ("accountMenu.usersManagement.roleAdmin" | transloco)
                  : ("accountMenu.usersManagement.roleUser" | transloco)
              }}
            </span>
          </div>

          <!-- Actions -->
          @if (currentUserService.isAdmin()) {
            <div class="flex gap-2">
              <app-user-form-popup
                mode="edit"
                [user]="user"
                (emitUserDTO)="editUser($event, user.id!)"
                (emitDelete)="confirmDelete(user.id!)"
                [loading]="isLoading"
              />
            </div>
          }
        </article>
      }
    </div>

    <app-user-limit-indicator />
  }
</section>
